export enum LocalStorageItems {
  ModerationFilterCriteria = 'MODERATION_FILTER_CRITERIA',
  ArticlesSearchBy = 'ARTICLES_SEARCH_BY',
  ArticlesSearchValue = 'ARTICLES_SEARCH_VALUE',
  ArticlesSortBy = 'ARTICLES_SORT_BY'
}

export enum AppealReasons {
  DisagreeGuidelines = 'disagree-guidelines',
  DontUnderstandGuidelines = 'dont-understand-guidelines',
  CommentFollowsGuidelines = 'comment-follows-guidelines',
  Misunderstanding = 'misunderstanding',
  WasNotAwareGuidelines = 'was-not-aware-guidelines',
  Other = 'other'
}

export enum ArticlesSearchByParams {
  Title = 'title',
  Url = 'url',
  ConversationId = 'conversation_id',
  ArticleId = 'post_id'
}

export enum ArticlesSortByParams {
  Newest = 'newest',
  Oldest = 'oldest',
  Pending = 'pending',
  Rejected = 'rejected',
  All = 'all'
}

export enum KeyboardKeys {
  Enter = 'Enter',
  Esc = 'Esc',
  Escape = 'Escape',
  ArrowDown = 'ArrowDown'
}

export enum SpotPolicy {
  ForceApproveAll = 'force_approve_all',
  ApproveAll = 'approve_all',
  PublishAndModerate = 'publish_and_moderate',
  RequireApproval = 'require_approval',
  BlockAll = 'block_all',
  ForceBlockAll = 'force_block_all'
}

export const ARTICLES_ITEMS_PER_PAGE = 10;
